const settings = {
    siteUrl: 'http://localhost:9000'
}

export { settings }


// WEBPACK FOOTER //
// ./src/framework/settings.js